export const GET_OPEN_HOUR = "GET_OPEN_HOUR";
export const GET_OPEN_HOUR_SUCCESS = "GET_OPEN_HOUR_SUCCESS";
export const GET_OPEN_HOUR_FAILURE = "GET_OPEN_HOUR_FAILURE";

export const UPDATE_OPEN_HOUR = "UPDATE_OPEN_HOUR";
export const UPDATE_OPEN_HOUR_SUCCESS = "UPDATE_OPEN_HOUR_SUCCESS";
export const UPDATE_OPEN_HOUR_FAILURE = "UPDATE_OPEN_HOUR_FAILURE";
